import classNames from 'classnames';
import type { FC } from 'react';
import {
  getSeverityBgClass,
  intentSeverityBadgeVariants,
} from './IntentVerification.styles';
import type { IntentSeverityBadgeProps } from './IntentVerification.types';

const styles = intentSeverityBadgeVariants();

export const IntentSeverityBadge: FC<IntentSeverityBadgeProps> = (props) => (
  <div className={styles.root()}>
    <div
      className={classNames(
        styles.indicator(),
        getSeverityBgClass(props.severity),
      )}
    >
      {props.default && <span className={styles.defaultMarker()}>D</span>}
    </div>
    <span className={styles.label()}>{props.children}</span>
  </div>
);
